module.exports = __webpack_public_path__ + "img/logo.3eee9cb8.png";